/**
 * Location Information - English v2
 * 
 * Effective Date: February 1, 2026
 */
export const LOCATION_V2_EN = {
    version: "v2",
    effectiveDate: "2026-02-01",
    language: "en",
    title: "Location Information",
    content: `
Location Information

Last Updated: February 1, 2026 (KST)

Spot Go ("Service") collects and uses personal location information in accordance with the "Act on the Protection and Use of Location Information."

1. Location Information Collector

Service Name: Spot Go
Contact: lukep81@painori.com

2. Location Information Collected

• GPS-based real-time location information (latitude, longitude)
• Approximate location information based on WiFi/cell towers

3. Purpose of Location Information Use

• Search for nearby Spots (stores/posts)
• Display location-based content
• Automatic location input when registering Spots
• Provide map services (Domestic: Naver Maps / International: Leaflet/OpenStreetMap)

4. Retention and Use Period of Location Information

• Real-time location: Used only while using the Service; not stored on servers.
• Spot registration location: Retained along with the post.
• Upon account deletion: All location-related data is deleted.

5. Third-Party Provision of Location Information

In principle, we do not provide location information to third parties.

Exceptions:
• When required by law
• External API calls for map services (Naver, Leaflet/OpenStreetMap)

6. User Rights

• You can withdraw consent to location information collection and use at any time.
• When consent is withdrawn, use of location-based services is restricted.
• Contact: lukep81@painori.com

7. If You Do Not Consent

⚠️ Important Notice

Spot Go is a location-based service. If you do not consent to location information collection, login is not possible and all content use is restricted.

You must consent to location information collection and use to use the Service.
`.trim()
};
